/**------------------------------------------------------
 * Type Definitions
 */
export type TypeClass<T> 			= new (...args: any[]) => T;
export type TypeAbstractClass<T> 	= abstract new (...args: any[]) => T;

export type TypeAnyClass 			= TypeClass<any>;
export type TypeAnyAbstractClass 	= TypeAbstractClass<any>;
